<template>
  <div class="game_main">
    <div class="game_up_div">
      <table border="0" class="game_up_div">
        <tr>
          <th width="55%" style="">
            <div class="game_img_div">
              <img class="game_img" :src="datas.homeImg" alt="">
            </div>
          </th>
          <th style="display: block;">
            <div class="game_text_div">
              <div class="txt_name">{{datas.name}}</div>
              <div class="txt_tips">{{datas.text}}</div>
              <div class="txt_tips">{{datas.tips}}</div>
            </div>
            <!-- <div class="game_go_h5">
              <img class="img_go_h5" src="@/assets/game/but_h5_pc.png" alt="" @click="onClickDown('go_h5')">
            </div> -->
            <div class="game_go_xcx_ma">
              <img class="img_go_xcx_ma" src="@/assets/xcx_ma.png" alt="" >
              <span class="txt_go_xcx_ma">微信小程序版（微信扫码进入）</span>
            </div>
          </th>
        </tr>
      </table>
    </div>
    <div class="game_bg" :style="gameBgStyle">
      <div class="txt_name">{{datas.appName}}</div>
      <div class="txt_tips_m">{{datas.appText}}</div>
      <div>
        <img class="down_but" src="@/assets/game/android_down.png" alt="" @click="onClickDown('down_apk')">
        <!-- <img class="down_but" src="@/assets/game/ios_down.png" alt="" @click="onClickDown('down_ipa')"> -->
        <img class="down_but" src="@/assets/game/but_h5_pc.png" alt="" @click="onClickDown('go_h5')">
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'GameAboutPC',
  components: {
  },
  props: [
    'datas', 'opts'
  ],
  data: () => {
    return {
    }
  },
  methods: {
    onClickDown (vtype) {
      this.$emit('events', vtype, this.datas)
    }
  },
  computed: {
    gameBgStyle () {
      return {
        'background-image': 'url(' + require('@/assets/game/bg.png') + ')'
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.game_main {
  padding: 0 0rem;
}
.game_img {
  border-radius: 8px;
}
.game_bg {
  padding: 0.3rem 1.6rem;
  color: #fff;
  background-repeat: no-repeat;
   background-size: 100% 100%;
}
.txt_name {
  font-size: 1.2rem;
  font-weight: bold;
  line-height: 2.8rem;
}
.txt_tips {
  font-size: 0.8rem;
  font-weight: lighter;
  margin: 5px 0;
}
.txt_tips_m {
  font-size: 0.8rem;
  font-weight: lighter;
  margin: 5px 0;
}
.down_but {
  margin: 0.3rem;
  width: 9rem;
  cursor: pointer;
}
.game_up_div {
  width: 100%;
}
.game_img_div {
  text-align: right;
}
.game_text_div {
  text-align: left;
  margin-left: 1.8rem;
  margin-top: 1rem;
}
.game_go_h5 {
  text-align: left;
}
.img_go_h5 {
  cursor: pointer;
  width: 12rem;
  margin-top: 1rem;
  margin-left: 1rem;
}
.game_go_xcx_ma{
  position: relative;
  text-align: left;
  margin-left: 2rem;
}
.img_go_xcx_ma{
  width: 8rem;
}
.txt_go_xcx_ma{
  position: absolute;
  top: 3.5rem;
  left: 8.5rem;
  font-size: 0.9rem;
  font-weight: bold;
  line-height: 1.2rem;
}
</style>
